import type { ICondition } from '@/Interfaces/CampaignManagement/LineItemStatusTooltip.interface';
import { Checkbox } from '@mui/material';
import { memo } from 'react';

interface IProps {
  conditions: ICondition[];
}

const LineItemStatusTooltipContent = memo(({ conditions }: IProps) => {
  return (
    <>
      <div className='italic'>
        {conditions.filter(cnd => cnd.checked).length} of {conditions.length} completed to activate
      </div>
      {conditions.map((cnd, i) => (
        <div key={i}>
          <Checkbox sx={{ paddingLeft: 0 }} disableRipple checked={cnd.checked} />
          <span>{cnd.condition}</span>
        </div>
      ))}
    </>
  );
});

export default LineItemStatusTooltipContent;
